// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchCreateSpecificationsCommand } from '../models';
// @ts-ignore
import type { BatchSpecificationResult } from '../models';
// @ts-ignore
import type { BatchUpdateSpecificationsCommand } from '../models';
// @ts-ignore
import type { CreateSpecificationCommand } from '../models';
// @ts-ignore
import type { SpecificationViewModel } from '../models';
// @ts-ignore
import type { UpdateSpecificationCommand } from '../models';
/**
 * SpecificationsApi - axios parameter creator
 * @export
 */
export const SpecificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {BatchCreateSpecificationsCommand} [batchCreateSpecificationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsBatchPost: async (companyName: string, id: string, batchCreateSpecificationsCommand?: BatchCreateSpecificationsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsBatchPost', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsBatchPost', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/specifications/batch`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateSpecificationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {BatchUpdateSpecificationsCommand} [batchUpdateSpecificationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsBatchPut: async (companyName: string, id: string, batchUpdateSpecificationsCommand?: BatchUpdateSpecificationsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsBatchPut', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsBatchPut', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/specifications/batch`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateSpecificationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsGet: async (companyName: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsGet', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsGet', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/specifications`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {string} parentSpecificationName 
         * @param {number} parentSequence 
         * @param {string} name 
         * @param {number} sequence 
         * @param {UpdateSpecificationCommand} [updateSpecificationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut: async (companyName: string, id: string, parentSpecificationName: string, parentSequence: number, name: string, sequence: number, updateSpecificationCommand?: UpdateSpecificationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'id', id)
            // verify required parameter 'parentSpecificationName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'parentSpecificationName', parentSpecificationName)
            // verify required parameter 'parentSequence' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'parentSequence', parentSequence)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'name', name)
            // verify required parameter 'sequence' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut', 'sequence', sequence)
            const localVarPath = `/api/equipment/{companyName}/{id}/specifications/{parentSpecificationName}/{parentSequence}/{name}/{sequence}`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"parentSpecificationName"}}`, encodeURIComponent(String(parentSpecificationName)))
                .replace(`{${"parentSequence"}}`, encodeURIComponent(String(parentSequence)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"sequence"}}`, encodeURIComponent(String(sequence)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpecificationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {CreateSpecificationCommand} [createSpecificationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsPost: async (companyName: string, id: string, createSpecificationCommand?: CreateSpecificationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsPost', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdSpecificationsPost', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/specifications`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSpecificationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecificationsApi - functional programming interface
 * @export
 */
export const SpecificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpecificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {BatchCreateSpecificationsCommand} [batchCreateSpecificationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdSpecificationsBatchPost(companyName: string, id: string, batchCreateSpecificationsCommand?: BatchCreateSpecificationsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchSpecificationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdSpecificationsBatchPost(companyName, id, batchCreateSpecificationsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecificationsApi.apiEquipmentCompanyNameIdSpecificationsBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {BatchUpdateSpecificationsCommand} [batchUpdateSpecificationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdSpecificationsBatchPut(companyName: string, id: string, batchUpdateSpecificationsCommand?: BatchUpdateSpecificationsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchSpecificationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdSpecificationsBatchPut(companyName, id, batchUpdateSpecificationsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecificationsApi.apiEquipmentCompanyNameIdSpecificationsBatchPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdSpecificationsGet(companyName: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpecificationViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdSpecificationsGet(companyName, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecificationsApi.apiEquipmentCompanyNameIdSpecificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {string} parentSpecificationName 
         * @param {number} parentSequence 
         * @param {string} name 
         * @param {number} sequence 
         * @param {UpdateSpecificationCommand} [updateSpecificationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(companyName: string, id: string, parentSpecificationName: string, parentSequence: number, name: string, sequence: number, updateSpecificationCommand?: UpdateSpecificationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(companyName, id, parentSpecificationName, parentSequence, name, sequence, updateSpecificationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecificationsApi.apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyName 
         * @param {string} id 
         * @param {CreateSpecificationCommand} [createSpecificationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdSpecificationsPost(companyName: string, id: string, createSpecificationCommand?: CreateSpecificationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdSpecificationsPost(companyName, id, createSpecificationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecificationsApi.apiEquipmentCompanyNameIdSpecificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpecificationsApi - factory interface
 * @export
 */
export const SpecificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpecificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsBatchPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchSpecificationResult> {
            return localVarFp.apiEquipmentCompanyNameIdSpecificationsBatchPost(requestParameters.companyName, requestParameters.id, requestParameters.batchCreateSpecificationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsBatchPut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchSpecificationResult> {
            return localVarFp.apiEquipmentCompanyNameIdSpecificationsBatchPut(requestParameters.companyName, requestParameters.id, requestParameters.batchUpdateSpecificationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsGet(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SpecificationViewModel>> {
            return localVarFp.apiEquipmentCompanyNameIdSpecificationsGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationViewModel> {
            return localVarFp.apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(requestParameters.companyName, requestParameters.id, requestParameters.parentSpecificationName, requestParameters.parentSequence, requestParameters.name, requestParameters.sequence, requestParameters.updateSpecificationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdSpecificationsPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationViewModel> {
            return localVarFp.apiEquipmentCompanyNameIdSpecificationsPost(requestParameters.companyName, requestParameters.id, requestParameters.createSpecificationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpecificationsApi - interface
 * @export
 * @interface SpecificationsApi
 */
export interface SpecificationsApiInterface {
    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApiInterface
     */
    apiEquipmentCompanyNameIdSpecificationsBatchPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchSpecificationResult>;

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApiInterface
     */
    apiEquipmentCompanyNameIdSpecificationsBatchPut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchSpecificationResult>;

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApiInterface
     */
    apiEquipmentCompanyNameIdSpecificationsGet(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SpecificationViewModel>>;

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApiInterface
     */
    apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationViewModel>;

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApiInterface
     */
    apiEquipmentCompanyNameIdSpecificationsPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationViewModel>;

}

/**
 * Request parameters for apiEquipmentCompanyNameIdSpecificationsBatchPost operation in SpecificationsApi.
 * @export
 * @interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest
 */
export interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPost
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPost
     */
    readonly id: string

    /**
     * 
     * @type {BatchCreateSpecificationsCommand}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPost
     */
    readonly batchCreateSpecificationsCommand?: BatchCreateSpecificationsCommand
}

/**
 * Request parameters for apiEquipmentCompanyNameIdSpecificationsBatchPut operation in SpecificationsApi.
 * @export
 * @interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest
 */
export interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPut
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPut
     */
    readonly id: string

    /**
     * 
     * @type {BatchUpdateSpecificationsCommand}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPut
     */
    readonly batchUpdateSpecificationsCommand?: BatchUpdateSpecificationsCommand
}

/**
 * Request parameters for apiEquipmentCompanyNameIdSpecificationsGet operation in SpecificationsApi.
 * @export
 * @interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest
 */
export interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGet
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGet
     */
    readonly id: string
}

/**
 * Request parameters for apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut operation in SpecificationsApi.
 * @export
 * @interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest
 */
export interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest {
    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly parentSpecificationName: string

    /**
     * 
     * @type {number}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly parentSequence: number

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly name: string

    /**
     * 
     * @type {number}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly sequence: number

    /**
     * 
     * @type {UpdateSpecificationCommand}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut
     */
    readonly updateSpecificationCommand?: UpdateSpecificationCommand
}

/**
 * Request parameters for apiEquipmentCompanyNameIdSpecificationsPost operation in SpecificationsApi.
 * @export
 * @interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest
 */
export interface SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPost
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPost
     */
    readonly id: string

    /**
     * 
     * @type {CreateSpecificationCommand}
     * @memberof SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPost
     */
    readonly createSpecificationCommand?: CreateSpecificationCommand
}

/**
 * SpecificationsApi - object-oriented interface
 * @export
 * @class SpecificationsApi
 * @extends {BaseAPI}
 */
export class SpecificationsApi extends BaseAPI implements SpecificationsApiInterface {
    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApi
     */
    public apiEquipmentCompanyNameIdSpecificationsBatchPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPostRequest, options?: RawAxiosRequestConfig) {
        return SpecificationsApiFp(this.configuration).apiEquipmentCompanyNameIdSpecificationsBatchPost(requestParameters.companyName, requestParameters.id, requestParameters.batchCreateSpecificationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApi
     */
    public apiEquipmentCompanyNameIdSpecificationsBatchPut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsBatchPutRequest, options?: RawAxiosRequestConfig) {
        return SpecificationsApiFp(this.configuration).apiEquipmentCompanyNameIdSpecificationsBatchPut(requestParameters.companyName, requestParameters.id, requestParameters.batchUpdateSpecificationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApi
     */
    public apiEquipmentCompanyNameIdSpecificationsGet(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsGetRequest, options?: RawAxiosRequestConfig) {
        return SpecificationsApiFp(this.configuration).apiEquipmentCompanyNameIdSpecificationsGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApi
     */
    public apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePutRequest, options?: RawAxiosRequestConfig) {
        return SpecificationsApiFp(this.configuration).apiEquipmentCompanyNameIdSpecificationsParentSpecificationNameParentSequenceNameSequencePut(requestParameters.companyName, requestParameters.id, requestParameters.parentSpecificationName, requestParameters.parentSequence, requestParameters.name, requestParameters.sequence, requestParameters.updateSpecificationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecificationsApi
     */
    public apiEquipmentCompanyNameIdSpecificationsPost(requestParameters: SpecificationsApiApiEquipmentCompanyNameIdSpecificationsPostRequest, options?: RawAxiosRequestConfig) {
        return SpecificationsApiFp(this.configuration).apiEquipmentCompanyNameIdSpecificationsPost(requestParameters.companyName, requestParameters.id, requestParameters.createSpecificationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

